export default {"src":"/_next/static/media/section_resources_1.bf23f561.svg","height":435,"width":1031};